import { BoxCollider } from "../Physics/BoxCollider";
import { CompoundBoxCollider } from "../Physics/CompoundBoxCollider";
import { IPhysicsBody } from "../Physics/IPhysicsBody";

// TODO:SH: This would be a lot cleaner if the colliders themselves had a reference to their parent's global position
export class Physics {
    private static _instance: Physics;

    private _tempA: BoxCollider;
    private _tempB: BoxCollider;

    private constructor() {
        this._tempA = new BoxCollider();
        this._tempB = new BoxCollider();
    }

    public static get instance(): Physics {
        if (this._instance === undefined) {
            this._instance = new Physics();
        }
        return this._instance;
    }

    public static boxVsBox(pA: BoxCollider, pB: BoxCollider): boolean {
        return pA.left < pB.right && pA.right > pB.left && pA.top < pB.bottom && pA.bottom > pB.top;
    }

    // TODO:SH: Find a way to clean up this nasty nesting
    public checkCollision(pA: IPhysicsBody, pB: IPhysicsBody): boolean {
        if (pA.active === false || pB.active === false) {
            return false;
        }
        if (pA.collider instanceof BoxCollider) {
            if (pB.collider instanceof BoxCollider) {
                return Physics.boxVsBox(
                    this._tempA.copy(pA.collider).offset(pA.position),
                    this._tempB.copy(pB.collider).offset(pB.position),
                );
            }
            else if (pB.collider instanceof CompoundBoxCollider) {
                for (let i = 0; i < pB.collider.boxes.length; ++i) {
                    if (Physics.boxVsBox(
                        this._tempA.copy(pA.collider).offset(pA.position),
                        this._tempB.copy(pB.collider.boxes[i]).offset(pB.position),
                    )) {
                        return true;
                    }
                }
                return false;
            }
        }
        else if (pA.collider instanceof CompoundBoxCollider) {
            if (pB.collider instanceof BoxCollider) {
                for (let i = 0; i < pA.collider.boxes.length; ++i) {
                    if (Physics.boxVsBox(
                        this._tempA.copy(pA.collider.boxes[i]).offset(pA.position),
                        this._tempB.copy(pB.collider).offset(pB.position),
                    )) {
                        return true;
                    }
                }
                return false;
            }
            else if (pB.collider instanceof CompoundBoxCollider) {
                for (let i = 0; i < pA.collider.boxes.length; ++i) {
                    for (let j = 0; i < pB.collider.boxes.length; ++j) {
                        if (Physics.boxVsBox(
                            this._tempA.copy(pA.collider.boxes[i]).offset(pA.position),
                            this._tempB.copy(pB.collider.boxes[j]).offset(pB.position),
                        )) {
                            return true;
                        }
                    }
                }
                return false;
            }
        }
        return false;
    }
}
